const contactForm = () => {
	const container = document.querySelector('.contact_form');
    
	if (!container) {
        return;
	}
    
    const successButton = container.querySelector('.contact_form__success_button');
	const revealSuccessState = () => {
		const main = container.querySelector('.contact_form__main');
		const success = container.querySelector('.contact_form__success');

		if (main) {
			main.classList.add('hide_form');
		}

		if (success) {
			success.classList.remove('initially-hidden');
		}
	};

	const gravityForm = container.querySelector('form[id^="gform_"]');
	const gravityFormId = gravityForm ? gravityForm.id.replace('gform_', '') : null;

	if (window.jQuery) {
		window.jQuery(document).on('gform_confirmation_loaded', (event, formId) => {
			if (!gravityFormId || String(formId) === String(gravityFormId)) {
				revealSuccessState();
			}
		});
	}

	if (successButton) {
		successButton.addEventListener('click', (event) => {
			event.preventDefault();
			window.location.reload();
		});
	}
};

export default contactForm;